/* Temporary request locks are separate from stock and validation availability. */
(() => {
  'use strict';
  if (window.NiralaBusyControls) return;

  function set(control, pending, unavailable = false, indicator = true) {
    if (!control) return;
    control.disabled = Boolean(pending || unavailable);
    control.setAttribute('aria-busy', String(Boolean(pending)));
    const temporary = pending && !unavailable && control.getAttribute('aria-disabled') !== 'true';
    control.toggleAttribute('data-nirala-busy', Boolean(temporary));
    if (temporary) control.dataset.niralaBusy = 'true';
    control.toggleAttribute('data-nirala-busy-indicator', Boolean(temporary && indicator));
  }

  function lock(control, indicator = false) {
    const disabled = control.disabled;
    const attributes = ['aria-busy', 'data-nirala-busy', 'data-nirala-busy-indicator'];
    const previous = attributes.map(name => [name, control.getAttribute(name)]);
    // A checkout verification can overlap an existing quantity request lock.
    // Preserve that temporary state instead of treating it as unavailable.
    set(control, true, disabled && control.dataset.niralaBusy !== 'true', indicator || control.hasAttribute('data-nirala-busy-indicator'));
    return () => {
      control.disabled = disabled;
      previous.forEach(([name, value]) => {
        if (value === null) control.removeAttribute(name);
        else control.setAttribute(name, value);
      });
    };
  }

  window.NiralaBusyControls = { set, lock };
})();
